var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}
window.Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};
window.Shopify.setSelectorByValue = function(selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
window.Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};
window.Shopify.postLink = function(path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};
  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
window.Shopify.CountryProvinceSelector = function(countryDomid, provinceDomid, options) {
  this.countryEl = document.getElementById(countryDomid);
  this.provinceEl = document.getElementById(provinceDomid);
  this.provinceContainer = document.getElementById(
    options.hideElement || provinceDomid
  );
  window.Shopify.addListener(
    this.countryEl,
    "change",
    window.Shopify.bind(this.countryHandler, this)
  );
  this.initCountry();
  this.initProvince();
};
window.Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    const value = this.countryEl.getAttribute("data-default");
    window.Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      window.Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function() {
    const opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const opt2 = document.createElement("option");
        opt2.value = provinces[i][0];
        opt2.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt2);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function(selector, values) {
    for (let i = 0, count = values.length; i < count; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
const selectors = {
  customerAddresses: "[data-customer-addresses]",
  addressCountrySelect: "[data-address-country-select]",
  addressContainer: "[data-address]",
  toggleAddressButton: "button[aria-expanded]",
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: "button[data-confirm-message]"
};
const attributes = {
  expanded: "aria-expanded",
  confirmMessage: "data-confirm-message"
};
class CustomerAddresses {
  constructor() {
    __publicField(this, "_handleAddEditButtonClick", ({ currentTarget }) => {
      this._toggleExpanded(currentTarget);
    });
    __publicField(this, "_handleCancelButtonClick", ({ currentTarget }) => {
      this._toggleExpanded(
        currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`)
      );
    });
    __publicField(this, "_handleDeleteButtonClick", ({ currentTarget }) => {
      if (window.confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
        window.Shopify.postLink(currentTarget.dataset.target, {
          parameters: { _method: "delete" }
        });
      }
    });
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }
  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(
        selectors.toggleAddressButton
      ),
      cancelButtons: container.querySelectorAll(
        selectors.cancelAddressButton
      ),
      deleteButtons: container.querySelectorAll(
        selectors.deleteAddressButton
      ),
      countrySelects: container.querySelectorAll(
        selectors.addressCountrySelect
      )
    } : {};
  }
  _setupCountries() {
    if (window.Shopify && window.Shopify.CountryProvinceSelector) {
      new window.Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew"
        }
      );
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        new window.Shopify.CountryProvinceSelector(
          `AddressCountry_${formId}`,
          `AddressProvince_${formId}`,
          {
            hideElement: `AddressProvinceContainer_${formId}`
          }
        );
      });
    }
  }
  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener("click", this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener("click", this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener("click", this._handleDeleteButtonClick);
    });
  }
  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === "false").toString()
    );
  }
}
new CustomerAddresses();
